import type { ShareErrorState } from '../models/share-view';

/**
 * The `extensions.code` values the share resolver can return. `GetReportHandler.ById`
 * emits `INVALID_ID` / `REPORT_NOT_FOUND`; `ListingReportAccessChecker.CheckReadAccess`
 * emits the rest. `Result.extractErrorFromGraphQL` forwards them verbatim.
 */
export type ShareErrorCode =
    | 'INVALID_ID'
    | 'REPORT_NOT_FOUND'
    | 'REPORT_EXPIRED'
    | 'AUTH_REQUIRED'
    | 'REPORT_DATA_MISSING'
    | 'ACCESS_DENIED';

const SHARE_ERROR_STATES: Record<string, ShareErrorState | undefined> = {
    INVALID_ID: 'not_found',
    REPORT_NOT_FOUND: 'not_found',
    REPORT_EXPIRED: 'expired',
    AUTH_REQUIRED: 'auth_required',
    REPORT_DATA_MISSING: 'access_denied',
    ACCESS_DENIED: 'access_denied'
} satisfies Record<ShareErrorCode, ShareErrorState>;

export function toShareErrorState(code: string): ShareErrorState {
    return SHARE_ERROR_STATES[code] ?? 'unknown';
}
